export const SET_LOADING = 'SET_LOADING'
export const SET_CLIENTS = 'SET_CLIENTS'
export const UPDATE_CLIENT = 'UPDATE_CLIENT'
export const DELETE_CLIENT = 'DELETE_CLIENT'
